/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import AnalysisIcons from "../../../CommonUi/AnalysisIcons/AnalysisIcons";
import {COMPLIANCE_COLOR_CODES} from "../../../../services/config";
import Tooltip from "components/CommonUi/Tooltip/Tooltip";
import {getDomainKey} from "../../../../helpers/domains";
import {useLanguage} from "../../../../LanguageContext";

type PositiveViewProps = {
  analysis: any;
  show?:string;
};
type ComplianceCode = "-1" | "0" | "1" | "2" | "3";

const PositiveView: React.FC<PositiveViewProps> = ({
  analysis,
  show,
}) => {
  const { t } = useLanguage();
  const wrapperClass = css`
    min-width: max-content;
  `;

  const responses = analysis?.response || analysis?.responses || [];
  const scrollToResultItem = (item: string) => {
    if (typeof document !== "undefined") {
      const element = document.getElementById(item);
      if (element) {
        const offset = document?.querySelector(".root-layout > div:first-child")?.getBoundingClientRect()?.height || 0;
        const rect = element.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const targetPosition: number = rect.top + scrollTop - (offset + 50);
        window.scrollTo({ top: targetPosition, behavior: "smooth" });
        element.click();
      }
    }
  };

  const containerStyle = css`
    display: flex;
    gap: 5px;
    justify-content: start;
    align-items: center;
    flex-wrap: wrap;
  `;
  return (
    <div css={containerStyle}>

      {responses.flatMap((resItem: any, index: number) =>
          resItem?.domains.map((dataItem: any)=>{
          let data =`#EAEEF0`;
          let content ='';
          if (["-1", "0", "1", "2", "3"].includes(dataItem?.category?.toString())) {
             let key = dataItem.category as ComplianceCode;
             data = COMPLIANCE_COLOR_CODES[key];
             content = t(`domain_${getDomainKey(dataItem?.domain_name)}`);
            }
            return (
              <Tooltip content={content} wrapperClass={wrapperClass}>
                <AnalysisIcons show={show} scrollTo={scrollToResultItem} imgName={dataItem?.domain_name} colorId={data? data :'#FFC400'} />
              </Tooltip>);
        }) || []
      )}
    </div>
  );
};

export default PositiveView;
